module.exports = "/_next/static/images/ourPartnersLumosLogo-9e55374b8b1db9faf4ccaf142e16f86d.webp";